import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';

export const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Entre com a sua conta corporativa (Entra ID)',
  apiRef: microsoftAuthApiRef,
};

// PDO-2364: em produção só Microsoft (Entra ID). Guest aparece apenas no
// `yarn start` local — no backend ele já recusa login fora de
// NODE_ENV=development, então o botão em produção só levaria a um erro.
export const signInProviders =
  process.env.NODE_ENV === 'development'
    ? (['guest', microsoftProvider] as const)
    : ([microsoftProvider] as const);

export function ByxSignInPage(props: Readonly<SignInPageProps>) {
  return <SignInPage {...props} providers={[...signInProviders]} />;
}

export const loadSignInPage = () => Promise.resolve(ByxSignInPage);

const byxSignInPage = SignInPageBlueprint.make({
  params: { loader: loadSignInPage },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [byxSignInPage],
});
